export type FormatType = "posev" | "nativ";
export type PlatformKey = "tg" | "vk" | "max" | "yt" | "dzen" | "tt" | "lk";

export type FormatEntry = {
  id: string;
  name: string;
  desc: string;
  price: number;
  cpv: number;
};

type PlatformFormats = Partial<Record<FormatType, FormatEntry[]>>;

export const FORMATS: Record<PlatformKey, PlatformFormats> = {
  tg: {
    posev: [
      { id: "1_24", name: "1/24", desc: "24 ч в топе",    price: 22000, cpv: 0.34 },
      { id: "2_48", name: "2/48", desc: "48 ч в ленте",   price: 28000, cpv: 0.44 },
      { id: "3_72", name: "3/72", desc: "72 ч в ленте",   price: 33000, cpv: 0.52 },
      { id: "30d",  name: "30 дней", desc: "",             price: 55000, cpv: 0.86 },
    ],
    nativ: [
      { id: "post", name: "Пост",      desc: "текст + медиа",  price: 38000, cpv: 0.59 },
      { id: "krug", name: "Кружочек", desc: "видео до 60 с",  price: 45000, cpv: 0.70 },
    ],
  },
  vk: {
    posev: [
      { id: "1_24", name: "1/24",    desc: "24 ч в топе",  price: 18000, cpv: 0.46 },
      { id: "2_48", name: "2/48",    desc: "48 ч в ленте", price: 23000, cpv: 0.59 },
      { id: "3_72", name: "3/72",    desc: "72 ч в ленте", price: 28000, cpv: 0.72 },
      { id: "30d",  name: "30 дней", desc: "весь месяц",   price: 45000, cpv: 1.15 },
    ],
    nativ: [
      { id: "klip",  name: "Клип",   desc: "вертикальное видео", price: 42000, cpv: 1.08 },
      { id: "post",  name: "Пост",   desc: "текст + медиа",      price: 32000, cpv: 0.82 },
      { id: "storis",name: "Сторис", desc: "24 ч, исчезает",     price: 25000, cpv: 0.64 },
    ],
  },
  max: {
    posev: [
      { id: "1_24", name: "1/24",    desc: "", price: 14000, cpv: 0.50 },
      { id: "2_48", name: "2/48",    desc: "", price: 18000, cpv: 0.64 },
      { id: "3_72", name: "3/72",    desc: "", price: 22000, cpv: 0.79 },
      { id: "30d",  name: "30 дней", desc: "", price: 36000, cpv: 1.29 },
    ],
    nativ: [
      { id: "post", name: "Пост", desc: "", price: 26000, cpv: 0.93 },
    ],
  },
  yt: {
    nativ: [
      { id: "shorts", name: "Шортс", desc: "до 60 сек",    price: 35000, cpv: 0.55 },
      { id: "video",  name: "Видео", desc: "полноформат",  price: 80000, cpv: 0.80 },
    ],
  },
  dzen: {
    nativ: [
      { id: "post_dzen", name: "Пост",    desc: "короткий",    price: 18000, cpv: 0.45 },
      { id: "statya",    name: "Статья",  desc: "SEO-формат",  price: 28000, cpv: 0.70 },
    ],
  },
  tt: {
    nativ: [
      { id: "klip_tt", name: "Клип", desc: "вертикальное видео", price: 50000, cpv: 0.62 },
    ],
  },
  lk: {
    nativ: [
      { id: "klip_lk", name: "Клип", desc: "вертикальное видео", price: 30000, cpv: 0.75 },
    ],
  },
};

export const AI_INSIGHTS: Record<string, string> = {
  "1_24":     "Пост 24 ч в топе — оптимален для охвата с ограниченным бюджетом",
  "2_48":     "Пост 48 ч — ~30% больше просмотров за счёт повторных визитов",
  "3_72":     "Пост 72 ч — лучший выбор для кампаний в будни",
  "30d":      "Пост 30 дней — для долгосрочного продвижения и SEO-эффекта",
  post:       "Нативный пост — блогер пишет сам, высокое доверие аудитории",
  post_dzen:  "Пост в Дзен — удобный формат для коротких материалов",
  krug:       "Кружочек до 60 с — ощущение личного обращения к аудитории",
  klip:       "Вертикальный клип — высокий вирусный потенциал",
  klip_tt:    "Клип в TikTok — максимальный охват молодой аудитории",
  klip_lk:    "Клип на Лайках — вертикальный формат с широким охватом",
  storis:     "Сторис 24 ч — создаёт срочность, хорошо для акций",
  shorts:     "YouTube Shorts — алгоритм YT даёт органический буст новым зрителям",
  video:      "Полноформатное видео — лучший ROI для сложных продуктов",
  statya:     "Статья в Дзен ранжируется в поиске Яндекс — долгосрочный трафик",
};

export const PLATFORM_LABELS: Record<PlatformKey, string> = {
  tg: "TG", vk: "VK", max: "МАХ", yt: "YT", dzen: "Дзен", tt: "TT", lk: "Лайки",
};

export const POSEV_PLATFORMS: PlatformKey[] = ["tg", "vk", "max"];
export const NATIV_PLATFORMS: PlatformKey[] = ["tg", "vk", "max", "yt", "dzen", "tt", "lk"];

export function getFormats(platform: PlatformKey, type: FormatType): FormatEntry[] {
  return FORMATS[platform]?.[type] ?? [];
}

export function normalizePlatform(platform: string): PlatformKey {
  const map: Record<string, PlatformKey> = {
    telegram: "tg", tg: "tg",
    vk: "vk",
    max: "max",
    youtube: "yt", yt: "yt",
    dzen: "dzen",
    tiktok: "tt", tt: "tt",
    likes: "lk", lk: "lk",
  };
  return map[platform] ?? "tg";
}

export function getDefaultPlatformForType(type: FormatType, current: PlatformKey): PlatformKey {
  const allowed = type === "posev" ? POSEV_PLATFORMS : NATIV_PLATFORMS;
  return allowed.includes(current) ? current : "tg";
}
